import { PUB_SUB_EVENTS } from '../helper/constants';
import { publish } from '../helper/pubsub';

class QuantitySelect extends HTMLElement {
  constructor() {
    super();
    this.decreaseButton = this.querySelector('.js-counter-remove');
    this.increaseButton = this.querySelector('.js-counter-add');
    this.input = this.querySelector('.js-counter-quantity');
  }

  connectedCallback() {
    if (!this.decreaseButton || !this.increaseButton || !this.input) return;

    const min = parseInt(this.input.getAttribute('min') || '1');
    const max = parseInt(this.input.getAttribute('max') || '10');

    let count = parseInt(this.input.value);

    const set = (i) => {
      count = Math.max(min, Math.min(i, max || 10000));
      // Update both the DOM property and the attribute
      this.input.value = count;
      this.input.setAttribute('value', count.toString());

      // Dispatch change event for form integration
      this.input.dispatchEvent(new Event('change', { bubbles: true }));

      // Publish a PubSub event for other components
      publish(PUB_SUB_EVENTS.quantityUpdate, {
        source: 'quantity-selector',
        quantity: count
      });
    };

    this.decreaseButton.addEventListener('click', (e) => {
      e.preventDefault();
      set(--count);
    });

    this.increaseButton.addEventListener('click', (e) => {
      e.preventDefault();
      set(++count);
    });
  }
}

customElements.define('quantity-select', QuantitySelect);
